import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AppState } from '../app';
import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';

export interface IntentsState {
  intents: IntentListItemViewModel[];
}

// initial state
export const intentsState: IntentsState = {
  intents: [],
};

export const intents: Module<IntentsState, AppState> = {
  namespaced: false,
  state: intentsState,
  getters,
  actions,
  mutations,
};
